export const GET_FILE_LINK = key => $get(`/mgt/file/url?key=${key}`)
// 获取上传文件的地址
export const POST_FILE_UPLOAD_URL = suffix => $post(`/mgt/file/upload/url?suffix=${suffix}`)
// 上传图片
export const PUT_IMAGE_UPLOAD = file => {
  return new Promise(async (resolve, reject) => {
    try {
      if (file.name.indexOf('.') === -1) {
        throw new Error('file type error')
      }
      const type = file.name.slice(file.name.lastIndexOf('.') + 1)
      const { data: { url, key } } = await POST_FILE_UPLOAD_URL(type)
      const contentType = 'svg' === type ? 'image/svg+xml' : 'image/jpeg'
      const { status } = await $put(url, file.raw, { headers: { 'Content-Type': contentType } })
      if (status !== 200) { throw Error('上传失败') }
      resolve({ url, key })
    } catch (e) {
      console.log('PUT_IMAGE_UPLOAD error', e)
      return reject(e)
    }
  })
}

// 字典类
// 官方模板类型
export const GET_DICT_OFFICE_TEMPLATE_TYPE = () => $get('/mgt/dict/officeTemplateType')
// 商品一级分类
export const GET_DICT_CATEGORY = () => $get('/mgt/dict/category')
// 商品二级分类
export const GET_DICT_SUB_CATEGORY = (parentId = '') => $get(`/mgt/dict/subCategory?parentId=${parentId}`)
// 商品规格
export const GET_DICT_STANDARD = (subCategoryId = '') => $get(`/mgt/dict/standard?parentId=${subCategoryId}`)
// 图标分类
export const GET_DICT_ICON_CATEGORY = () => $get('/mgt/dict/iconCategory')
// 帮助类目
export const GET_DICT_CLASSIFICATION = () => $get('/mgt/dict/classification')


// 用户
// 登录
export const LOGIN = params => $post('/mgt/account/login', params)
export const LOGOUT = () => $post('/mgt/account/logout')

// 轮播图
export const GET_SLIDE_SHOWS = params => $get('/mgt/slideshows', params)
export const POST_SLIDE_SHOWS = (id, params) => $post(`/mgt/slideshows/${id}`, params)
export const PUT_SLIDE_SHOWS = params => $put('/mgt/slideshows', params)
export const DEL_SLIDE_SHOWS = id => $delete(`/mgt/slideshows/${id}`)
export const POST_SLIDE_SHOWS_UNDELETE = id => $post(`/mgt/slideshows/${id}/undelete`)

// 字体
export const GET_FONTS = params => $get('/mgt/fonts', params)
export const POST_FONTS = (id, params) => $post(`/mgt/fonts/${id}`, params)
export const PUT_FONTS = params => $put('/mgt/fonts', params)
export const DEL_FONTS = id => $delete(`/mgt/fonts/${id}`)
export const POST_FONTS_UNDELETE = id => $post(`/mgt/fonts/${id}/undelete`)

// 反馈
export const GET_FEEDBACKS = params => $get('/mgt/feedbacks', params)
export const DEL_FEEDBACK = id => $delete(`/mgt/feedbacks/${id}/process-status`)
export const PUT_FEEDBACK = (id, params) => $put(`/mgt/feedbacks/${id}/process-status`, params)

// 官方模版
export const GET_OFFICE_TEMPLATES = params => $get('/mgt/officeTemplates', params)
export const POST_OFFICE_TEMPLATES = (id, params) => $post(`/mgt/officeTemplates/${id}`, params)
export const PUT_OFFICE_TEMPLATES = params => $put('/mgt/officeTemplates', params)
export const DEL_OFFICE_TEMPLATES = id => $delete(`/mgt/officeTemplates/${id}`)
export const POST_OFFICE_TEMPLATES_UNDELETE = id => $post(`/mgt/officeTemplates/${id}/undelete`)

// 官方模版类型
export const GET_OFFICE_TEMPLATE_TYPES = params => $get('/mgt/officeTemplateType', params)
export const POST_OFFICE_TEMPLATE_TYPES = (id, params) => $post(`/mgt/officeTemplateType/${id}`, params)
export const PUT_OFFICE_TEMPLATE_TYPES = params => $put('/mgt/officeTemplateType', params)
export const DEL_OFFICE_TEMPLATE_TYPES = id => $delete(`/mgt/officeTemplateType/${id}`)
export const POST_OFFICE_TEMPLATE_TYPES_UNDELETE = id => $post(`/mgt/officeTemplateType/${id}/undelete`)

// 商品
export const GET_GOODS = params => $get('/mgt/goods', params)
export const POST_GOODS = (id, params) => $post(`/mgt/goods/${id}`, params)
export const PUT_GOODS = params => $put('/mgt/goods', params)
export const DEL_GOODS = id => $delete(`/mgt/goods/${id}`)
export const POST_GOODS_UNDELETE = id => $post(`/mgt/goods/${id}/undelete`)

// 商品一级分类
export const GET_CATEGORIES = params => $get('/mgt/categories', params)
export const POST_CATEGORIES = (id, params) => $post(`/mgt/categories/${id}`, params)
export const PUT_CATEGORIES = params => $put('/mgt/categories', params)
export const DEL_CATEGORIES = id => $delete(`/mgt/categories/${id}`)
export const POST_CATEGORIES_UNDELETE = id => $post(`/mgt/categories/${id}/undelete`)

// 商品二级分类
export const GET_SUB_CATEGORIES = params => $get('/mgt/subCategories', params)
export const POST_SUB_CATEGORIES = (id, params) => $post(`/mgt/subCategories/${id}`, params)
export const PUT_SUB_CATEGORIES = params => $put('/mgt/subCategories', params)
export const DEL_SUB_CATEGORIES = id => $delete(`/mgt/subCategories/${id}`)
export const POST_SUB_CATEGORIES_UNDELETE = id => $post(`/mgt/subCategories/${id}/undelete`)

// 商品规格
export const GET_STANDARDS = params => $get('/mgt/standards', params)
export const POST_STANDARDS = (id, params) => $post(`/mgt/standards/${id}`, params)
export const PUT_STANDARDS = params => $put('/mgt/standards', params)
export const DEL_STANDARDS = id => $delete(`/mgt/standards/${id}`)
export const POST_STANDARDS_UNDELETE = id => $post(`/mgt/standards/${id}/undelete`)

// 图标
export const GET_ICONS = params => $get('/mgt/icons', params)
export const POST_ICONS = (id, params) => $post(`/mgt/icons/${id}`, params)
export const PUT_ICONS = params => $put('/mgt/icons', params)
export const DEL_ICONS = id => $delete(`/mgt/icons/${id}`)
export const POST_ICONS_UNDELETE = id => $post(`/mgt/icons/${id}/undelete`)

// 图标分类
export const GET_ICON_CATEGORIES = params => $get('/mgt/iconCategories', params)
export const POST_ICON_CATEGORIES = (id, params) => $post(`/mgt/iconCategories/${id}`, params)
export const PUT_ICON_CATEGORIES = params => $put('/mgt/iconCategories', params)
export const DEL_ICON_CATEGORIES = id => $delete(`/mgt/iconCategories/${id}`)
export const POST_ICON_CATEGORIES_UNDELETE = id => $post(`/mgt/iconCategories/${id}/undelete`)

// 帮助分类
export const GET_CLASSIFICATIONS = params => $get('/mgt/classifications', params)
export const POST_CLASSIFICATIONS = (id, params) => $post(`/mgt/classifications/${id}`, params)
export const PUT_CLASSIFICATIONS = params => $put('/mgt/classifications', params)
export const DEL_CLASSIFICATIONS = id => $delete(`/mgt/classifications/${id}`)
export const POST_CLASSIFICATIONS_UNDELETE = id => $post(`/mgt/classifications/${id}/undelete`)

// 帮助内容
export const GET_FAQS = params => $get('/mgt/faqs', params)
export const POST_FAQS = (id, params) => $post(`/mgt/faqs/${id}`, params)
export const PUT_FAQS = params => $put('/mgt/faqs', params)
export const DEL_FAQS = id => $delete(`/mgt/faqs/${id}`)
export const POST_FAQS_UNDELETE = id => $post(`/mgt/faqs/${id}/undelete`)

// 用户
export const GET_USERS = params => $get('/mgt/users', params)
export const PUT_USERS_ADMIN = id => $put(`/mgt/users/${id}/admin`)
export const DEL_USERS_ADMIN = id => $delete(`/mgt/users/${id}/admin`)

// 用户模板
export const GET_USER_TEMPLATES = params => $get('/mgt/templates', params)
export const GET_USER_TEMPLATE = id => $get(`/mgt/templates/${id}`)

// 行业
export const GET_INDUSTRIES = params => $get('/mgt/industries', params)
export const POST_INDUSTRIES = (id, params) => $post(`/mgt/industries/${id}`, params)
export const PUT_INDUSTRIES = params => $put('/mgt/industries', params)
export const DEL_INDUSTRIES = id => $delete(`/mgt/industries/${id}`)
export const POST_INDUSTRIES_UNDELETE = id => $post(`/mgt/industries/${id}/undelete`)

// 客户端版本
export const GET_APP_VERSIONS = params => $get('/mgt/appVersions', params)
export const POST_APP_VERSIONS = (id, params) => $post(`/mgt/appVersions/${id}`, params)
export const PUT_APP_VERSIONS = params => $put('/mgt/appVersions', params)
export const DEL_APP_VERSIONS = id => $delete(`/mgt/appVersions/${id}`)
export const POST_APP_VERSIONS_UNDELETE = id => $post(`/mgt/appVersions/${id}/undelete`)
